
  import { stringify } from 'qs';
  import Pagination from 'vue-pagination-2';
  import PaginationTemplate from '@/components/widgets/pagination-template';
  import { scrollToTop } from '~/scripts/utils';

  export default {
    components: { Pagination },
    props: {
      allowedParams: { type: Array, default: () => [] }
    },
    data () {
      return {
        paginationOptions: {
          chunk: 5,
          chunksNavigation: 'scroll',
          edgeNavigation: true,
          texts: {
            count: '',
            first: this.$t('first'),
            last: this.$t('last'),
            nextPage: this.$t('next'),
            prevPage: this.$t('prev')
          },
          template: PaginationTemplate
        }
      };
    },
    computed: {
      currentPage: {
        get () {
          return parseInt(this.pagination.page);
        },
        set (page) {
          this.$store.commit('utils/setPagination', { page });
        }
      },
      pagination () {
        return { ...this.$store.getters['utils/getPagination'], ...{ options: this.paginationOptions } };
      }
    },
    mounted () {
      this.currentPage = this.pagination.page;
    },
    methods: {
      goToPage (page) {
        let pagePath = `${this.$route.path}/?${stringify({ ...this.$route.query, ...{ page } })}`.replace(/\/+/g, '/');
        if (page === 1) {
          pagePath = `${this.$route.path}`;
        }

        this.$router.push(pagePath);
        scrollToTop();
      }
    }
  };
